import { createContext, useContext, useState, type ReactNode } from "react";

interface BrandingState {
  slug: string | null;
  brand: string | null;
  setBranding: (slug: string, brand: string) => void;
}

const KEY = "pulse_branding";
const BrandingContext = createContext<BrandingState | undefined>(undefined);

function readInitial(): { slug: string | null; brand: string | null } {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (raw) return JSON.parse(raw) as { slug: string | null; brand: string | null };
  } catch {
    /* ignore */
  }
  return { slug: null, brand: null };
}

export function BrandingProvider({ children }: { children: ReactNode }) {
  const initial = readInitial();
  const [slug, setSlug] = useState<string | null>(initial.slug);
  const [brand, setBrand] = useState<string | null>(initial.brand);

  const setBranding = (s: string, b: string) => {
    setSlug(s);
    setBrand(b);
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ slug: s, brand: b }));
    } catch {
      /* sessionStorage no disponible → degradar silenciosamente */
    }
  };

  return (
    <BrandingContext.Provider value={{ slug, brand, setBranding }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding(): BrandingState {
  const ctx = useContext(BrandingContext);
  if (!ctx) throw new Error("useBranding must be used within BrandingProvider");
  return ctx;
}
